<template>
  <div>
    <v-form>
      <v-text-field
        v-if="context !== 'create'"
        v-model="localReport.name"
        :label="$tc('name')"
        :error-messages="nameErrors"
        prepend-inner-icon="mdi-form-textbox"/>
      <vf-autocomplete
        v-model="reportCustomers"
        :items="availableCustomers"
        :error-messages="customerErrors"
        :label="$tc('customer', 2)"/>
      <div class="d-flex align-center">
        <date-picker
          v-model="startDate"
          :timezone="timezone"
          :output-moment="true"
          :label="$t('start_date')"
          prepend-inner-icon="mdi-calendar"
          :error-messages="dateRangeErrors"
          :reset-on-timezone-change="context === 'create'"/>
        <span class="text-subtitle-1 mx-2">{{ $t('to') }}</span>
        <date-picker
          v-model="endDate"
          :timezone="timezone"
          :output-moment="true"
          :end-of-day="true"
          :label="$t('end_date')"
          prepend-inner-icon="mdi-calendar"
          :error="dateRangeErrors.length > 0"
          :reset-on-timezone-change="context === 'create'"/>
      </div>
      <date-selector-shortcuts :lowerBound.sync="startDate" :upperBound.sync="endDate" :timezone="timezone" :show-title="false"/>
    </v-form>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import ReportFormMixin from '@/components/report/ReportFormMixin'
import DatePicker from '@/components/shared/DatePicker'
import DateSelectorShortcuts from '@/components/report/DateSelectorShortcuts'
import VfAutocomplete from '@/components/shared/VfAutocomplete'
import ReportUtils from '@/components/report/ReportUtils'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { map } from 'lodash'

export default {
  name: 'VehicleCountReportForm',
  components: {
    DatePicker,
    DateSelectorShortcuts,
    VfAutocomplete
  },
  mixins: [
    CurrentUserMixin,
    ApiUtilitiesMixin,
    ValidationMixin,
    ReportFormMixin
  ],
  validations: {
    reportCustomers: {
      required
    },
    localReport: {
      name: {
        required: requiredIf(function () {
          return this.action !== 'create'
        })
      }
    },
    dateRange: {
      rangeIsValid: function () {
        return ReportUtils.dateRangeIsValid(this.startDate, this.endDate)
      }
    }
  },
  data () {
    return {
      reportType: 'VehicleCountReport',
      startDate: null,
      endDate: null,
      reportCustomers: []
    }
  },
  computed: {
    availableCustomers () {
      return map(this.customers, customer => {
        return {
          value: customer.id,
          text: customer.name
        }
      })
    },
    customerErrors () {
      return this.validationErrors([{
        prop: this.$v.reportCustomers,
        message: this.$t('customer_required')
      }])
    },
    dateRangeErrors () {
      return this.validationErrors([{
        prop: this.$v.dateRange,
        message: this.$t('invalid_date_range')
      }])
    },
    nameErrors () {
      return this.validationErrors([{
        prop: this.$v.localReport.name,
        message: this.$t('required')
      }])
    }
  },
  methods: {
    populateReportForm () {
      this.preSelectDates()
      this.preSelectCustomers()
    },
    buildReportParameters () {
      const reportParameters = {}
      reportParameters.startDate = this.startDate.format()
      reportParameters.endDate = this.endDate.format()
      reportParameters.customerIds = this.reportCustomers
      reportParameters.timezone = this.timezone
      return reportParameters
    },
    defaultReportName () {
      return this.$t('reports_ui.vehicle_count_report.name')
    }
  }
}
</script>

<style scoped>

</style>
